/**
 * Defines status result.
 */
export enum Status {
    /**
     * The only status informs about fail.
     */
    Failed = 'Failed',
    /**
     * Success.
     */
    Success = 'Success',
    /**
     * Same as {@link Status.Success} but with minor problem.
     */
    SuccessWithWarning = 'SuccessWithWarning',
}
